// RANKING セクション — タブ切り替え + Splide（非表示タブは遅延マウント）

function mountRankingSplide(root) {
  if (!root || root.dataset.splideMounted === 'true' || typeof Splide === 'undefined') return;

  const splide = new Splide(root, {
    type: 'slide',
    fixedWidth: '270px',
    gap: '40px',
    arrows: true,
    pagination: false,
    perMove: 1,
    drag: true,
    i18n: window.cmSplideI18n || {},
    breakpoints: {
      767: {
        fixedWidth: '160px',
        gap: '16px',
        arrows: false,
      },
    },
  });

  splide.mount();
  root.dataset.splideMounted = 'true';
  root.splideInstance = splide;
}

function destroyRankingSplide(root) {
  if (!root?.splideInstance) return;
  root.splideInstance.destroy();
  delete root.splideInstance;
  delete root.dataset.splideMounted;
}

function initRankingTabs(section) {
  const tabGroup = section.querySelector('[data-ranking-tabs]');
  if (!tabGroup) return;

  const buttons = tabGroup.querySelectorAll('.cm-tab-group__button');
  const panels = section.querySelectorAll('[data-ranking-panel]');

  const firstPanel = section.querySelector('[data-ranking-panel][data-index="0"]');
  if (firstPanel) {
    const firstSplide = firstPanel.querySelector('[data-splide-ranking]');
    if (firstSplide) mountRankingSplide(firstSplide);
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetIndex = button.dataset.index;

      buttons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      panels.forEach((panel) => {
        if (panel.dataset.index === targetIndex) {
          panel.removeAttribute('hidden');

          const splideRoot = panel.querySelector('[data-splide-ranking]');
          if (splideRoot) mountRankingSplide(splideRoot);
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });
}

function initRankingSplides(container = document) {
  container.querySelectorAll('[data-splide-ranking]').forEach((root) => {
    if (root.closest('.cm-featured-ranking')) return;
    mountRankingSplide(root);
  });
}

function initRankingSections(container = document) {
  container.querySelectorAll('.cm-featured-ranking').forEach(initRankingTabs);
  initRankingSplides(container);
}

function destroyRankingSections(container = document) {
  container.querySelectorAll('[data-splide-ranking]').forEach(destroyRankingSplide);
}

document.addEventListener('DOMContentLoaded', () => {
  initRankingSections();
});

document.addEventListener('shopify:section:load', (event) => {
  initRankingSections(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyRankingSections(event.target);
});

window.cmFeaturedRanking = {
  mount: mountRankingSplide,
  destroy: destroyRankingSplide,
};
